module.exports = __webpack_public_path__ + "img/IconCancel.29106377.svg";